<app-section-quick-actions section="wingedLight" />

<header class="atmos-page__header">
  <h1 class="atmos-page__title">Wing Buffs</h1>
  <div class="atmos-wing-buffs__count" aria-live="polite">
    <strong [class.atmos-wing-buffs__count-complete]="unlocked === total && total > 0">{{ unlocked }}</strong>
    <span class="atmos-wing-buffs__count-sep"> / {{ total }}</span>
    <span class="atmos-wing-buffs__count-label"> wing buffs</span>
  </div>
</header>

<div class="atmos-card atmos-wing-buffs__grid-card">
  <ag-grid-angular
    [rowData]="rowData"
    [columnDefs]="colDefs"
    [theme]="theme"
    [suppressDragLeaveHidesColumns]="true"
    [domLayout]="'autoHeight'"
    (gridReady)="onGridReady($event)"/>
</div>
